import { connect, Dispatch } from 'react-redux';
import { RootState } from '../../../store/reducers';
import PrimaryNav from './PrimaryNav';
import { primaryNavClick } from '../../../store/action';
import { NavActions } from '../../../store/action/primaryNavActions';

const mapStateToProps = (state: RootState) => {
    const { appReducer, navReducer, profileReducer, generalReducer, deltaReducer } = state;
    const loading = appReducer.loading;
    const navId = navReducer.navId;
    const { isValid: profileValid } = profileReducer;
    const { isComplete: generalValid } = generalReducer;
    const { isValid: deltaValid } = deltaReducer;

    const deltaDisabled = true;
    const resultsDisabled = true;

    return {
        loading,
        navId,
        profileValid,
        generalValid,
        deltaValid,
        deltaDisabled,
        resultsDisabled
    };
};

const mapDispatchToProps = (dispatch: Dispatch<NavActions>) => {
    return {
        profileNavClick(navId: string, valid: boolean): void {
            if (!valid) { return; }
            dispatch(primaryNavClick(navId, valid));
        },
        generalNavClick(navId: string, valid: boolean): void {
            if (!valid) { return; }
            dispatch(primaryNavClick(navId, valid));
        },
        deltaNavClick(navId: string, disabled: boolean): void {
            if (disabled) { return; }
            dispatch(primaryNavClick(navId, disabled));
        },
        resultsNavClick(navId: string, disabled: boolean): void {
            if (disabled) { return; }
            dispatch(primaryNavClick(navId, disabled));
        }
    };
};

const PrimaryNavContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PrimaryNav);

export default PrimaryNavContainer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/nav/topNav/PrimaryNavContainer.tsx